import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

const branding = {
  icons: {
    information: InfoOutlinedIcon,
    confirmation: TaskAltOutlinedIcon,
  },
};

export default branding;
